import React, { useEffect } from 'react';
import { UrgencyBar } from './UrgencyBar';
import { HeroSection } from './HeroSection';
import { HookSection } from './HookSection';
import { PainSection } from './PainSection';
import { RevelationSection } from './RevelationSection';
import { TestimonialsSection } from './TestimonialsSection';
import { ValueStack } from './ValueStack';
import { TestimonialsPrePricing } from './TestimonialsPrePricing';
import { PricingSection } from './PricingSection';
import { FAQSection } from './FAQSection';
import { CommitmentSection } from './CommitmentSection';
import { Footer } from './Footer';
export function SalesPage() {
  useEffect(() => {
    document.title = 'El Escudo Hormonal 40+';
  }, []);
  return <div className="min-h-screen bg-white font-body text-brand-gray selection:bg-brand-gold/30 selection:text-brand-green" data-id="element-226">
      <UrgencyBar data-id="element-227" />
      <main data-id="element-228">
        <HeroSection data-id="element-229" />
        <HookSection data-id="element-230" />
        <PainSection data-id="element-231" />
        <RevelationSection data-id="element-232" />
        <TestimonialsSection data-id="element-233" />
        <ValueStack data-id="element-234" />
        <TestimonialsPrePricing data-id="element-235" />
        <PricingSection data-id="element-236" />
        <FAQSection data-id="element-237" />
        <CommitmentSection data-id="element-238" />
      </main>

      <Footer data-id="element-239" />
    </div>;
}